// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1SFvO","insightsList":"newBusinessInsightsMenu_insightsList__2rVfb","active":"newBusinessInsightsMenu_active__2S73p"};